module.exports = __webpack_public_path__ + "h5/img/spread_bag.f65b2921.png";